import { render, staticRenderFns } from "./Nouveaux.vue?vue&type=template&id=b037461c&scoped=true&"
import script from "./Nouveaux.vue?vue&type=script&lang=js&"
export * from "./Nouveaux.vue?vue&type=script&lang=js&"
import style0 from "./Nouveaux.vue?vue&type=style&index=0&id=b037461c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b037461c",
  null
  
)

export default component.exports